const hasIntersectionSupport = () => typeof window !== "undefined" && window.IntersectionObserver;

export { hasIntersectionSupport as h };
